import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { WorkspaceDto } from '../dto/WorkspaceDto';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiUpdateTable = async (
  section: string,
  route: string,
  page: string,
  dto: WorkspaceDto
) => {
  const params: IApiParams = {
    url: `/admin/saveTable.php?section=${section}&route=${route}&page=${page}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
